export default __webpack_public_path__ + "static/Bm_ELIB_EzyMedical_ClaimGuide-6834537582c056aa8b7893c766f0352c.pdf";